angular
    .module("skillBuilderSaaS")
    .directive("iframeIgnoreOneTrust", ([function () {
        return {
            restrict: "A",
            priority: 10,
            link: function (scope, element, attrs) {
                scope.$watch(attrs.ngBindHtml, function () {
                    element.find("iframe").attr("data-ot-ignore", "");
                });
            }
        };
    }]));
